export const STEP_FACTOR = 0.005;
export const STEP_ANGLE = STEP_FACTOR * Math.PI;
